:host {
  width: 100%;

  --row-gap: var(--stzh-row-row-gap, 0px);
}

@mixin cellProps($breakpoint: null) {
  @for $i from 1 through $gridCells {
    @if $breakpoint {
      :host([span-#{$breakpoint}="#{$i}"])
      ::slotted(stzh-cell:not([span-#{$breakpoint}])) {
        @include mq($from: $breakpoint) {
          --cell-width: #{100% / ($gridCells / $i)};
        }
      }
    } @else {
      :host([span="#{$i}"])
      ::slotted(stzh-cell:not([span])) {
        --cell-width: #{100% / ($gridCells / $i)};
      }
    }
  }
}

@include cellProps();

@each $breakpoint, $size in $breakpoints {
  @include cellProps($breakpoint);
}

.stzh-row {
  display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
  row-gap: var(--row-gap);
  margin-left: calc(#{$gridGutter} / -2);
  margin-right: calc(#{$gridGutter} / -2);

  @include mq($from: small) {
    margin-left: calc(#{$gridGutterSmall} / -2);
    margin-right: calc(#{$gridGutterSmall} / -2);
  }

  @include mq($from: medium) {
    margin-left: calc(#{$gridGutterMedium} / -2);
    margin-right: calc(#{$gridGutterMedium} / -2);
  }

  @include mq($from: large) {
    margin-left: calc(#{$gridGutterLarge} / -2);
    margin-right: calc(#{$gridGutterLarge} / -2);
  }

  @include mq($from: ultra) {
    margin-left: calc(#{$gridGutterUltra} / -2);
    margin-right: calc(#{$gridGutterUltra} / -2);
  }

  /* Justify content variants */

  &--justify-end {
    justify-content: flex-end;
  }

  &--justify-center {
    justify-content: center;
  }

  &--justify-between {
    justify-content: space-between;
  }

  &--justify-around {
    justify-content: space-around;
  }

  &--justify-evenly {
    justify-content: space-evenly;
  }

  /* Align items variants */

  &--items-end {
    align-items: flex-end;
  }

  &--items-center {
    align-items: center;
  }

  &--items-baseline {
    align-items: baseline;
  }

  &--items-stretch {
    align-items: stretch;
  }

  /* Align content variants */

  &--content-end {
    align-content: flex-end;
  }

  &--content-center {
    align-content: center;
  }

  &--content-between {
    align-content: space-between;
  }

  &--content-around {
    align-content: space-around;
  }

  &--content-evenly {
    align-content: space-evenly;
  }
}
